import { Controller } from 'stimulus'
import ClipboardJS from 'clipboard'

const DEFAULT_COPIED_MESSAGE = 'Copied to your clipboard.'
const DEFAULT_COPY_FAILED_MESSAGE = 'Could not copy - sorry!'

export default class extends Controller {
  static targets = ['action', 'content']
  static values = {
    copiedMessage: String,
    copyFailedMessage: String,
  }

  connect() {
    if (!this.hasActionTarget) return

    const clipboard = new ClipboardJS(this.actionTarget, {
      target: () => this.contentTarget,
    })

    clipboard.on('success', () => {
      alert(this.copiedMessage)
    })
    clipboard.on('error', () => {
      alert(this.copyFailedMessage)
    })

    if (ClipboardJS.isSupported()) {
      this.actionTarget.classList.remove('hidden')
    }
  }

  get copiedMessage() {
    return this.hasCopiedMessageValue && this.copiedMessageValue
      ? this.copiedMessageValue
      : DEFAULT_COPIED_MESSAGE
  }

  get copyFailedMessage() {
    return this.hasCopyFailedMessageValue && this.copyFailedMessageValue
      ? this.copyFailedMessageValue
      : DEFAULT_COPY_FAILED_MESSAGE
  }
}
